<form ngForm #form class="row">
  <div *ngIf="showOldPasswordConfirmation" class="col-12">
    <h3>{{ 'Change Password' | translate }}</h3>
    <p>{{ 'password rules information' | translate }}</p>
  </div>
  <div *ngIf="showOldPasswordConfirmation" class="col-12" [ngClass]="easyMode ? 'col-sm-12' : 'col-sm-6'" >
    <app-input [title]='"Old Password" | translate' [name]="'oldPassword'" [type]='"password"' [(ngModel)]="password.oldPassword"
      required #oldPassword="ngModel"></app-input>
  </div>
  <div *ngIf="showOldPasswordConfirmation" class="col-12 col-sm-6">
  </div>
  <div *ngIf="!showOldPasswordConfirmation" class="col-12 pb-3">
    {{ 'The password must be at least 8 characters long, consists of uppercase and lowercase letters and at least one number.' | translate }}
  </div>
  <div class="col-12" [ngClass]="easyMode ? 'col-md-12' : 'col-md-6'" >
    <app-input [title]='(showOldPasswordConfirmation ? "New Password" : "Password") | translate' [name]="'password'" [type]='"password"'
      [(ngModel)]="password.password" appValidateEqual="repeatPassword" reverse="true" required #passwordRef="ngModel" appValidatePasswordPolicy></app-input>
  </div>
  <div class="col-12 col-sm-6">
    <app-input *ngIf="!easyMode"  [title]='"Repeat Password" | translate' [name]="'repeatPassword'" [type]='"password"' [(ngModel)]="password.repeatPassword"
      appValidateEqual="password" reverse="false" required #repeatPasswordRef="ngModel" appValidatePasswordPolicy></app-input>
  </div>
</form>
